import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { setPreferences } from '../modules/preferences/actions';
import { getPreferences } from '../modules/preferences/selectors';
import Filters from '../modules/booking/components/Filters';
import { fetchOffers, fetchArrivalsAndDepartures } from '../actions/preferenceActions';

class SearchForm extends Component {
  state = {
    results: []
  }

  componentDidMount = () => {
    const { focus, preferences, setSubjects, setKinds } = this.props;
    if (focus && focus.subjects && !preferences.subjects) {
      setSubjects(focus.subjects);
    }

    if (focus && focus.kinds.length > 0 && !preferences.kinds.length) {
      setKinds(focus.kinds);
    }

    this.fetchResults();
  }

  fetchResults = () => {
    this.props.fetchArrivalsAndDepartures();
    return this.props.fetchOffers()
    .then((data) => {
      if (!data) return null;
      return this.setState({ results: data.results });
    });
  }

  render = () => (
    <div className="loading-block loading-pr transparent">
      <div className="container">
        <div id="filters" className="row row-pb">
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-12">
                <div className="filters">
                  <div className="tab-content row">
                    <Filters
                      template="search_form"
                      focus={this.props.focus}
                      results={this.state.results}
                      onChange={this.fetchResults}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

SearchForm.propTypes = {
  fetchArrivalsAndDepartures: PropTypes.func,
  fetchOffers: PropTypes.func.isRequired,
  focus: PropTypes.object,
  preferences: PropTypes.object,
  setSubjects: PropTypes.func,
  setKinds: PropTypes.func
};

const mapStateToProps = state => ({
  preferences: getPreferences(state)
});

const mapDispatchToProps = dispatch => ({
  fetchArrivalsAndDepartures: () => dispatch(fetchArrivalsAndDepartures()),
  fetchOffers: () => dispatch(fetchOffers()),
  setSubjects: subjects => dispatch(setPreferences(subjects, 'subjects')),
  setKinds: kinds => dispatch(setPreferences(kinds, 'kinds'))
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchForm);
